import { useState, useEffect, useCallback } from "react";
import { ADMIN_SUCCESS_DISMISS_MS } from "../constants";

/**
 * Hook that manages an auto-dismissing message (success/info).
 * Replaces the repeated pattern of useState + useEffect + setTimeout
 * found across all admin components.
 *
 * @param dismissMs - Time in ms before the message auto-clears (default: ADMIN_SUCCESS_DISMISS_MS)
 * @returns [message, setMessage, clearMessage]
 */
export function useAutoDismiss(dismissMs: number = ADMIN_SUCCESS_DISMISS_MS) {
  const [message, setMessage] = useState<string | null>(null);

  useEffect(() => {
    if (!message) return;
    const timer = setTimeout(() => setMessage(null), dismissMs);
    return () => clearTimeout(timer);
  }, [message, dismissMs]);

  const clearMessage = useCallback(() => setMessage(null), []);

  return [message, setMessage, clearMessage] as const;
}